import React, { useState } from 'react';
import { postCrearProducto } from '../../Servicios/Servicios';
import { useSpinner } from '../../Component/spinner/spinner';

const ModalCrearProducto = ({ onClose, consultaInventario }) => {
  const [imagen, setImagen] = React.useState('');
  const [nombre, setNombre] = React.useState('');
  const [valor, setValor] = React.useState('');
  const [categoriaSeleccionada, setCategoriaSeleccionada] = useState("");
  const spinner = useSpinner();

  const todasLasCategorias = [
    "Entradas",
    "Cocteles",
    "Platos fuertes",
    "Cervezas",
    "Bebidas",
    "Postres",
    "Bebidas alcohólicas",
  ];
  const convertirImagenABase64 = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    if (!file.type.startsWith('image/')) {
      console.error("El archivo seleccionado no es una imagen");
      return;
    }
    const reader = new FileReader();
    reader.readAsDataURL(file);

    reader.onloadend = () => {
      const base64 = reader.result;
      setImagen(base64); // si estás usando useState
    };

    reader.onerror = () => {
      console.error("Error al leer el archivo");
    };
  };
  const handleChange = (e) => {
    setCategoriaSeleccionada(e.target.value);
  };
  const handledSummit = async () => {
    spinner.show();
    const form = {
      nombre: nombre,
      precio: valor,
      categoria: categoriaSeleccionada,
      imagen: imagen,
    }
    // Aquí podrías manejar el envío del formulario
    if (!form.nombre || !form.precio || !form.categoria || !form.imagen) {
      console.error("Por favor, completa todos los campos obligatorios.");
      spinner.hide();
      return;
    }
    const crearProducti = await postCrearProducto(form);
    if (crearProducti.success) {
      alert(crearProducti.message);
      consultaInventario(); // Actualizar el inventario después de crear el producto
      onClose(); // Cerrar el modal después de crear el producto
      spinner.hide();
      setNombre('');
      setValor('');
      setCategoriaSeleccionada('');
      setImagen('');

    }else {
      console.error("Error al crear el producto:", crearProducti.message);
      alert("Error al crear el producto. Por favor, verifica los datos ingresados.");
      spinner.hide();
    }
  }
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
      <div className="w-[400px] sm:w-[500px] rounded-2xl p-6 shadow-xl relative my-20 mx-8" id="CuadrosEstandarColor">
        
        {/* Botón cerrar */}
        <button onClick={onClose} className="absolute top-4 right-4 text-gray-400 hover:text-black text-xl font-bold">×</button>

        <h2 className="text-[#4F60A8] text-xl font-bold mb-4">Crear producto</h2>

        {/* Nombre del producto */}
        <input
          value={nombre}
          onChange={(e) => setNombre(e.target.value)}
          type="text"
          placeholder="Nombre"
          className="w-full mb-4 border rounded-lg px-4 py-2 bg-gray-100 placeholder-gray-500"
        />

        {/* Imagen */}
        <div className="bg-[#D9D6F5] border border-[#4F60A8] text-center text-sm text-[#4F60A8] py-2 px-4 rounded-xl mb-5">
          <label htmlFor="file-upload" className="cursor-pointer">
            <div className="flex justify-center mb-2 text-3xl">📷</div>
            Mínima resolución de 800px x 800px <br />
            Archivos PNG, JPEG
          </label>
        </div>
        <input
          type="file" 
          accept="image/*"
          id="file-upload"
          onChange={(e) =>convertirImagenABase64(e)}
          className="w-full file-input border rounded-lg px-4 py-2 bg-gray-100 placeholder-gray-500 mb-4"
          style={{ display: 'none' }} // Ocultar el input de archivo
        />
        {/* Categorías */}
        <div className="mb-4">
          <p className="mb-2 font-medium text-white bold">Selecciona una categoría</p>
          <div className="grid grid-cols-2 gap-2 text-sm text-white ">
            {todasLasCategorias.map((categoria) => (
              <label key={categoria}>
                <input
                  type="radio"
                  name="categoria" // importante para agrupar los radios
                  value={categoria}
                  onChange={handleChange}
                  checked={categoriaSeleccionada === categoria}
                  className="mr-2"
                />
                {categoria}
              </label>
            ))}
          </div>
        </div>

        {/* Valor del item */}
        <input
          type="number"
          placeholder="Ingrese el valor"
          value={valor}
          onChange={(e) => setValor(e.target.value)}
          className="w-full mb-4 border rounded-lg px-4 py-2 bg-gray-100 placeholder-gray-500 text-sm"
        />

        {/* Descripción */}
        {/* <textarea
          placeholder="Agregue una descripción"
          className="w-full border rounded-lg px-4 py-2 bg-gray-100 placeholder-gray-500 text-sm"
          rows={2}
        /> */}
        {/* Botón */}
        <button
          onClick={handledSummit}
          className="mt-3 w-full bg-[#4F60A8] text-white py-3 rounded-full hover:bg-[#3d4b8a] transition text-sm">
          Crear producto
        </button>
      </div>
    </div>
  );
};

export default ModalCrearProducto;
